import type { I18nProvider } from '@refinedev/core'
import type { i18n as I18n } from 'i18next'

/**
 * Refine's `i18nProvider` on the panel's i18next. Refine asks with a key and
 * its own English text (`translate(key, options, defaultMessage)`, or
 * `translate(key, defaultMessage)`): a key the catalog lacks answers that
 * text, never the raw key, so every Refine title, button and notification
 * stays readable until its page is extracted. Without a text it answers the
 * key, which Refine reads as "no translation".
 */
export function createI18nProvider(i18n: I18n): I18nProvider {
  return {
    translate: (key, options, defaultMessage) => {
      const [values, fallback] =
        typeof options === 'string'
          ? [{}, options]
          : [(options ?? {}) as Record<string, unknown>, defaultMessage]
      return i18n.t(key, {
        ...values,
        ...(fallback === undefined ? {} : { defaultValue: fallback }),
      })
    },
    changeLocale: (language) => i18n.changeLanguage(language),
    getLocale: () => i18n.language,
  }
}
